import { ElementTextBlockPositionType, HorizontalAlignType, PaletteColorType, PositionType, TextStyleType } from "../constants";
import { BaseCategory } from "./BaseCategory";
import { SlideCategories } from "./CategoryController";
import { SlideModelBuilder } from "./SlideModelBuilder";

export class TextCategory extends BaseCategory {
    get name() {
        return "Text";
    }

    get type() {
        return SlideCategories.TEXT;
    }

    get icon() {
        return null;
    }

    get description() {
        return "The content contain one or more sentences of text that is not a list or factoid. Use for free-form text or key concepts, definitions, or unstructured content that is not a list or diagram.  You can use this category if the content is primarily textual information but includes one or more images.";
    }

    get slideTypes() {
        return [];
    }

    getPrompt() {
        return `Provide the text for the slide.`;
    }

    getImagePrompt() {
        return "Optionally and if appropriate, you can also suggest a prompt for generating an image to use on the slide. The image should be a single subject or abstract concept related to the topic of the slide.";
    }

    getPromptSchema() {
        return {
            label: "an optional short label or title for the text content",
            text: "richtext for the slide",
            conclusion: "an optional short conclusion or takeaway for the slide. plain text only, no rich text",
        };
    }

    validateGeneratedModel(model) {
        if (!this.validateArray(model.text)) {
            return false;
        }
        return true;
    }

    getSlideModels(model) {
        let models = [
            model.slideImage && this.buildText(model, true, { headlinePosition: PositionType.RIGHT, dividerSize: 0.6666 }),
            model.slideImage && this.buildText(model, true, { headlinePosition: PositionType.LEFT, dividerSize: 0.5, showGutter: false }),
            // this.buildText(model, true, { headlinePosition: PositionType.BACKGROUND}),
            this.buildText(model, false, {}),
        ].filter(m => m);

        return models;
    }

    buildText(model, showImage, props) {
        let builder = new SlideModelBuilder("headline2", model);

        let primary = {
            fullBleed: true,
            showGutter: true,
            headlinePosition: PositionType.LEFT,
            textPosition: PositionType.LEFT,
            textAlign: HorizontalAlignType.LEFT,
            ...props,
            text: {
                blocks: [
                    builder.createBlock(model.label, TextStyleType.LABEL, { fontColor: PaletteColorType.THEME }),
                    builder.createBlock(model.slideTitle, TextStyleType.HEADING),
                    ...builder.cleanUpRichText(model.text)
                ]
            },
        };

        for (let i = 1; i < primary.text.blocks.length; i++) {
            let block = primary.text.blocks[i];
            block.spaceAbove = 10;
        }

        if (model.slideImage?.prompt && showImage) {
            // primary.backdropStyle = "white_box";
            primary.items = [{
                componentType: "TextAndImage",
                childElement: builder.createImage(model.slideImage?.prompt, {}, true)
            }];
        }

        builder.createPrimary(primary);

        if (model.conclusion) {
            builder.createBottomTray(model.conclusion, ElementTextBlockPositionType.TRAY);
        }

        return builder.model;
    }
}

